<template>
  <div
    v-if="loading"
    class="wxguide-wrapper">
    <div class="part1">
      <img
        src="https://pic.lehe.com/pic/_o/18/10/be6d6d7cd7c558188279657dcf88_442_414.cz.png"
        class="part1-img">
      <img
        src="https://pic.lehe.com/pic/_o/17/e4/f15f4e250cad17a6d5539a572f85_320_28.cz.png"
        class="prt1-img2">
      <p class="part1-title">
        小着 | 新型的社区空间
      </p>
      <p class="part1-tip">
        给最热爱美感和设计的人们
      </p>
      <input
        type="button"
        class="download-btn"
        value="立即下载"
        @click="goDownload">
    </div>
    <img
      src="https://pic.lehe.com/pic/_o/03/8c/d9ef649452650acc4b13bb08ab3d_750_1000.cz.png"
      class="prt2">
    <div class="part3">
      <p>
        我们给最热爱美感和设计的、喜欢创造新东西的、
      </p>
      <p>
        热诚、挑剔、有趣的人们，创造了一系列非常有美
      </p>
      <p>
        感和设计的实体空间、产品和服务，
      </p>
      <p>
        让他们更有灵感和能量，让他们彼此连接，
      </p>
      <p>
        让他们更好取得事业和生活的进步。
      </p>
    </div>
    <div class="part4">
      <img
        src="https://pic.lehe.com/pic/_o/2f/6b/92edabf1d08ae976d7694935a8b7_750_500.cz.png"
        class="par4-img1">
      <div class="part4-content">
        <img
          src="https://pic.lehe.com/pic/_o/2c/81/3762929929b9ebebc905996b31fc_242_362.cz.png"
          class="content-img">
        <img
          src="https://pic.lehe.com/pic/_o/1e/0d/24cc0a35f81d27295e3b5a6d21e3_242_362.cz.png"
          class="content-img">
        <img
          src="https://pic.lehe.com/pic/_o/ae/c4/a2c4c7d3c0c0f3d4499489bd4601_242_362.cz.png"
          class="content-img">
      </div>
    </div>
    <div class="part5">
      <p class="part5-title">
        THINK SMALL, CREATE BIG.
      </p>
      <div class="part5-content">
        <p>
          我们的使命，
        </p>
        <p>
          是让中国有全世界最好的美感和进步。
        </p>
        <p>
          我们相信，设计是美感和进步的载体，
        </p>
        <p>
          是可以改变世界的力量。
        </p>
        <p>
          我们拥抱，全世界优秀的设计师和创新者。
        </p>
      </div>
    </div>
    <div class="part6">
      <div>
        <input
          type="button"
          class="download-btn"
          value="立即下载">
      </div>
      <img
        src="https://pic.lehe.com/pic/_o/e0/92/bdd31554a2ed836076b27681e459_120_76.cz.png"
        class="part6-img">
      <div class="part6-tip">
        给最热爱美感和设计的人们
      </div>
    </div>
    <div
      v-show="maskShow"
      class="mask-wrapper"
      @click="maskShow = false">
      <div
        class="mask"
        @click.stop>
        <img
          src="https://pic.lehe.com/pic/_o/8b/14/fd42cc4472ad4388f7a3c63ca3c5_60_60.cz.png"
          class="mask-img1">
        <div class="mask-content">
          <img
            src="https://pic.lehe.com/pic/_o/f0/a6/b30aa0ea8e41edec9ba6f30a15cd_60_60.cz.png"
            class="mask-img2">
          <div class="mask-text">
            <p>
              点击右上角
            </p>
            <p>
              选择浏览器打开
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      link: '',
      maskShow: false,
      isAndroid: true,
      isIOS: false
    }
  },
  mounted () {
    // 设置字号
    var e = 'orientationchange' in window ? 'orientationchange' : 'resize'
    var b = document.documentElement
    var c = function () {
      b.style.fontSize = window.innerWidth / 750 * 100 + 'px'
    }
    c()
    window.addEventListener(e, c, !1)
    document.getElementsByTagName('html')[0].style.minHeight = window.innerHeight + 'px'

    // 判断手机操作系统
    const u = navigator.userAgent
    this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    if (this.isIOS) {
      this.link = 'https://apps.apple.com/cn/app/id1491885384'
    } else {
      this.link = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.shimao.xiaozhuo'
    }
    this.loading = true
    this.goDownload()
  },
  methods: {
    isWeixin () {
      // 判断是不是微信浏览器
      const ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
        return true
      }
      return false
    },
    goDownload () {
      if (this.isAndroid && this.isWeixin()) {
        this.maskShow = true
        return false
      }
      location.href = this.link
    }
  }
}
</script>

<style lang="scss">
@import '@/style/var/color.scss';
  .wxguide-wrapper {
    .download-btn {
      width: 3.2rem;
      height: .88rem;
      line-height: .88rem;
      color: #fff;
      background-color: $main-color;
      border-radius: 6px;
      font-size: .32rem;
    }
    .part1 {
      padding: 1.74rem 0 1.6rem;
      text-align: center;
      background-color: #fff;
      font-size: 0;
      .part1-img {
        width: 4.42rem;
        height: 4.14rem;
      }
      .prt1-img2 {
        width: 3.2rem;
        height: .28rem;
        margin-top: .52rem;
      }
      .part1-title {
        margin-top: .98rem;
        line-height: .74rem;
        font-size: .52rem;
        color: #333;
        font-weight: 600;
      }
      .part1-tip {
        margin-top: .2rem;
        line-height: .44rem;
        font-size: .32rem;
        color: #333;
      }
      .download-btn {
        margin-top: .6rem;
      }
    }
    .prt2 {
      width: 100%;
    }
    .part3 {
      padding: .8rem .4rem;
      p {
        margin-top: .45rem;
        font-size: .30rem;
        color: #222;
        &:first-of-type {
          margin-top: 0
        }
      }
    }
    .part4 {
      .par4-img1 {
        width: 100%;
      }
      .part4-content {
        margin-top: .1rem;
        display: flex;
        justify-content: space-between;
        .content-img {
          width: 2.42rem;
          height: 3.62rem;
        }
      }
    }
    .part5 {
      padding: .8rem .4rem .96rem;
      color: #222;
      border-bottom: 2px solid #e9e9e9;
      .part5-title {
        line-height: .66rem;
        font-size: .48rem;
        font-weight: 800;
      }
      .part5-content {
        margin-top: .4rem;
        p {
          font-size: .3rem;
          margin-top: .45rem;
          &:first-of-type {
            margin-top: 0;
          }
        }
      }
    }
    .part6 {
      padding: 1.2rem 0 1rem;
      text-align: center;
      font-size: 0;
      .download-btn {
        width: 4rem;
      }
      .part6-img {
        margin-top: 1rem;
        width: 1.2rem;
      }
      .part6-tip {
        margin-top: .2rem;
        font-size: .24rem;
        line-height: .34rem;
        color: #333;
      }
    }
    .mask-wrapper {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      background-color: rgba(0, 0, 0, .6);
      .mask {
        padding: .5rem .4rem 0 0;
        text-align: right;
        font-size: 0;
        .mask-img1 {
          width: .4rem;
          height: .4rem;
        }
        .mask-content {
          margin-top: .3rem;
          text-align: left;
          overflow: hidden;
          .mask-img2 {
            float: left;
            width: .4rem;
            height: .4rem;
            margin-right: .15rem;
          }
          .mask-text {
            margin-top: .08rem;
            width: 1.96rem;
            color: #fff;
            font-size: .28rem;
            p {
              margin-bottom: .2rem;
            }
          }
        }
      }
    }
  }
</style>
